import { useMemo } from 'react'
import { ShopStripePayout } from 'types/graphql'

const useReportedYears = (payouts: ShopStripePayout[]): number[] => {
  return useMemo(() => {
    if (!payouts || payouts.length === 0) return []
    return payouts.reduce((prev: number[], payout) => {
      const year = new Date(payout.createdDate).getFullYear()
      if (prev.includes(year)) return prev
      return [...prev, year]
    }, [])
  }, [payouts])
}

export default useReportedYears
